import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

const translations = {
  'en-US': {
    'email-address': 'Email address',
    'event-stream-community': 'News',
    'event-stream-event': 'Events',
    'event-tag-event': 'Event',
    'event-tag-news': 'News',
    feedback: 'Feedback',
    'feedback-check-all-required-fields-are-filled': 'Check that all required fields are filled',
    'feedback-email': 'Your email address',
    'feedback-email-invalid': 'Email address seems invalid',
    'feedback-fill-required-field': 'Fill required field',
    'feedback-name': 'Name',
    'feedback-privacy-policy': 'Privacy policy',
    'feedback-required-fields-marked-by-star': 'Required fields are marked by star',
    'feedback-rsvp': 'I wish to be replied',
    'feedback-select-store': 'Choose a store',
    'feedback-select-target': 'Select target of the feedback',
    'feedback-send': 'Send',
    'feedback-target-general': 'I want to give general feedback',
    'feedback-target-store': 'I want to give feedback to specific store',
    'feedback-thank-you': 'Thank you for the feedback!',
    'feedback-type': 'Type of feedback',
    'feedback-type-thanks': 'Thanks',
    'feedback-type-suggestion': 'Suggestion',
    'feedback-type-complaint': 'Complaint',
    'feedback-type-other': 'Other',
    'fob-all': 'All stores',
    'fob-1': 'Fashion and accessories',
    'fob-2': 'Daily consumer goods',
    'fob-3': 'Interior and home',
    'fob-4': 'Beauty and health',
    'fob-5': 'Cafès and restaurants',
    'fob-6': 'Entertainment and leisure',
    'fob-7': 'Other services',
    map: 'Floor Map',
    "mylly's-giftcard": "Mylly's giftcard!",
    'tax-free': 'Tax free',
    'pet-friendly': 'Pet friendly',
    offers: 'Offers',
    'offers-all': 'Show all',
    'offers-and-services': 'Offers and Services',
    'offers-show-more': 'Show all offers',
    'offers-stream-basic': 'Offers',
    'offers-stream-whats-new': "What's new",
    'click-for-all-opening-hours':'Click for all opening hours',
    'open-map': 'Open map',
    'opening-hours': 'Opening hours',
    'arrival': "Arrival",
    'info': "Info",
    'opening-hours-exceptional': 'Exceptional opening hours',
    'opening-hours-exceptions': 'Exceptions!',
    'opening-status-by_appoinment': 'By appoinment',
    'opening-status-closed': 'Closed',
    'opening-status-open': 'Open',
    'opening-status-temporary_closed': 'Temporarily closed',
    'read-more': 'Read more',
    'lowestPrice30': '30 day lowest price',
    search: 'Search…',
    'search-menu': 'Looking for something?',
    'language': "Language",
    'show-all': 'Show all',
    'show-on-map': 'Show on map',
    'on-map': 'Map',
    'we-accept': 'We accept',
    news: 'News',
    'other-news': 'Other news and events',
    stores: 'Stores',
    'search-no-result': 'Sorry, your search has no result',
    'toggle-navigation': 'Toggle navigation',
    'toggle-search': 'Toggle search',
    'search-not-match-any-results':'Your search did not match any results',

    'offers.allDays': 'All days',
    'offers.allCategories': 'All categories',
    'offers.allOffers': 'All offers',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Close',
    'offers.seeWholeOffer': 'See whole offer',
    'offers.noOffers': 'Unfortunately no offers are currently available',
    'offers.noContent':'No content currently available',
    'offers.searchBox':'Search',
    'offers.clearSelection': 'Clear selection',
    'offers.openInfo':'Open offer description',
    'offers.daysLowestPrice': '30 day lowest price',
    'offers.valid': 'Valid',
    'offers.store': 'Store',
    'offers.offer': 'Offer',
    'search.noResults': 'No results',
    'search.placeholder': 'Search',
    'store.status.BY_APPOINTMENT': 'By appointment',
    'store.status.CLOSED': 'Closed',
    'store.status.OPEN': 'Open',
    'store.status.TEMPORARY_CLOSED': 'Temporarily closed',
  },
  'fi-FI': {
    'email-address': 'Sähköpostiosoite',
    'event-stream-community': 'Uutiset',
    'event-stream-event': 'Tapahtumat',
    'event-tag-event': 'Tapahtuma',
    'event-tag-news': 'Uutinen',
    feedback: 'Palaute',
    'feedback-check-all-required-fields-are-filled':
    'Tarkista, että olet täyttänyt kaikki pakolliset kentät',
    'feedback-email': 'Sähköpostiosoitteesi',
    'feedback-email-invalid': 'Sähköpostiosoite ei kelpaa',
    'feedback-fill-required-field': 'Pakollinen kenttä täyttämättä',
    'feedback-name': 'Nimi',
    'feedback-privacy-policy': 'Rekisteriseloste',
    'feedback-required-fields-marked-by-star': 'Pakolliset tiedot on merkitty tähdellä',
    'feedback-rsvp': 'Haluan, että minulle vastataan',
    'feedback-select-store': 'Valitse liike',
    'feedback-select-target': 'Valitse palutteen kohde',
    'feedback-send': 'Lähetä',
    'feedback-target-general': 'Haluan antaa yleistä palautetta',
    'feedback-target-store': 'Haluan antaa palautetta tietylle toimijalle',
    'feedback-thank-you': 'Kiitos palautteestasi!',
    'feedback-type': 'Palautteen tyyppi',
    'feedback-type-thanks': 'Kiitos',
    'feedback-type-suggestion': 'Ehdotus',
    'feedback-type-complaint': 'Moite',
    'feedback-type-other': 'Muu',
    'fob-all': 'Kaikki liikkeet',
    'fob-1': 'Tyyli ja asusteet',
    'fob-2': 'Päivittäistavara',
    'fob-3': 'Sisustaminen ja koti',
    'fob-4': 'Kauneus ja terveys',
    'fob-5': 'Kahvilat ja ravintolat',
    'fob-6': 'Viihde ja vapaa-aika',
    'fob-7': 'Muut palvelut',
    map: 'Kartta',
    "mylly's-giftcard": 'Myllyn lahjakortti!',
    'tax-free': 'Tax-free-myynti EU:n ulkopuolelle',
    'pet-friendly': 'Lemmikit tervetulleita',
    offers: 'Tarjoukset',
    'offers-all': 'Katso kaikki',
    'offers-and-services': 'Tarjoukset ja palvelut',
    'offers-show-more': 'Näytä kaikki tarjoukset',
    'offers-stream-basic': 'Tarjoukset',
    'offers-stream-whats-new': 'Uutuudet',
    'click-for-all-opening-hours':'Liikkeiden aukioloajat',
    'open-map': 'Avaa pohjakartta',
    'opening-hours': 'Aukioloajat',
    'arrival': "Saapuminen",
    'info': "Info",
    'opening-hours-exceptional': 'Poikkeusaukioloajat',
    'opening-hours-exceptions': 'Poikkeuksia!',
    'opening-status-by_appoinment': 'Sop.muk.',
    'opening-status-closed': 'Suljettu',
    'opening-status-open': 'Avoinna',
    'opening-status-temporary_closed': 'Tilapäisesti suljettu',
    'read-more': 'Lue lisää',
    'lowestPrice30': '30 pv alin hinta',
    'search': 'Hae…',
    'search-menu': 'Haetko jotain? Hae tästä',
    'language': "Kieli",
    'show-all': 'Näytä kaikki',
    'show-on-map': 'Näytä kartalla',
    'on-map': 'Kartalla',
    'we-accept': 'Meillä käy',
    news: 'Ajankohtaista',
    'other-news': 'Muuta ajankohtaista',
    stores: 'Liikkeet',
    'search-no-result': 'Haku ei valitettavasti tuottanut tulosta',
    'toggle-navigation': 'Avaa/sulje navikaatio',
    'toggle-search': 'Avaa/sulje haku',
    'search-not-match-any-results': 'Haku ei vastannut yhtään osumaa',

    'offers.allDays': 'Kaikki päivät',
    'offers.allCategories': 'Kaikki toimialat',
    'offers.allOffers': 'Kaikki tarjoukset',
    'offers.showWishList': 'Näytä muistilista',
    'offers.closeOffer': 'Sulje',
    'offers.seeWholeOffer': 'Avaa koko tarjous',
    'offers.noOffers': 'Etuja ei valitettavasti tällä hetkellä ole saatavilla',
    'offers.noContent':'Ei näytettävää sisältöä juuri nyt',
    'offers.searchBox':'Haku',
    'offers.clearSelection': 'Tyhjennä valinnat',
    'offers.openInfo':'Avaa lisätiedot',
    'offers.daysLowestPrice': '30 pv alin hinta',
    'offers.valid': 'Voimassa',
    'offers.store': 'Liike',
    'offers.offer': 'Tarjous',
    'search.noResults': 'Ei tuloksia',
    'search.placeholder': 'Hae',
    'store.status.BY_APPOINTMENT': 'Sopimuksen mukaan',
    'store.status.CLOSED': 'Suljettu',
    'store.status.OPEN': 'Avoinna',
    'store.status.TEMPORARY_CLOSED': 'Tilapäisesti suljettu',
  },
  'sv-SE': {
    'email-address': 'Epostadress',
    'event-stream-community': 'Nyheter',
    'event-stream-event': 'Evenemang',
    'event-tag-event': 'Evenemang',
    'event-tag-news': 'Nyheter',
    feedback: 'Feedback',
    'feedback-check-all-required-fields-are-filled':
    'Kontrollera att alla obligatoriska fält är ifyllda',
    'feedback-email': 'Din epostadress',
    'feedback-email-invalid': 'Epostadressenn verkar vara ogiltig',
    'feedback-fill-required-field': 'Fyll i det obligatoriska fältet',
    'feedback-name': 'Namn',
    'feedback-privacy-policy': 'Integritetspolicy',
    'feedback-required-fields-marked-by-star':
    'De obligatoriska fälten är markerade med en stjärna',
    'feedback-rsvp': 'Jag önskar få svar',
    'feedback-select-store': 'Välj en butik',
    'feedback-select-target': 'Välj återkopplingens mottagare',
    'feedback-send': 'Sänd',
    'feedback-target-general': 'Jag vill ge allmän återkoppling',
    'feedback-target-store': 'Jag vill ge återkoppling till en specifik butik',
    'feedback-thank-you': 'Tack för återkopplingen!',
    'feedback-type': 'Typ av återkoppling',
    'feedback-type-thanks': 'Tack',
    'feedback-type-suggestion': 'Förslag',
    'feedback-type-complaint': 'Klagomål',
    'feedback-type-other': 'Annat',
    'fob-all': 'Alla butiker',
    'fob-1': 'Mode och accessoarer',
    'fob-2': 'Dagligvaror',
    'fob-3': 'Inredning och hem',
    'fob-4': 'Skönhet och hälsa',
    'fob-5': 'Cafèer och restauranger',
    'fob-6': 'Nöje och fritid',
    'fob-7': 'Andra tjänster',
    map: 'Grundkarta',
    "mylly's-giftcard": 'Mylly:s presentkort!',
    offers: 'Erbjudanden',
    'offers-all': 'Visa alla',
    'offers-and-services': 'Erbjudanden och tjänster',
    'offers-show-more': 'Visa alla erbjudanden',
    'offers-stream-basic': 'Erbjudanden',
    'offers-stream-whats-new': 'Aktuellt',
    'offers.store': 'Butiker',
    'offers.offer': 'Erbjudanden',
    'offers.valid': 'Gäller',
    'click-for-all-opening-hours':'Klicka för alla öppettider',
    'open-map': 'Öppna karta',
    'opening-hours': 'Öppettider',
    'arrival': "Besök",
    'info': "Info",
    'opening-hours-exceptional': 'Avvikande öppettider',
    'opening-hours-exceptions': 'Avvikelser!',
    'opening-status-by_appoinment': 'Enligt överenskommelse',
    'opening-status-closed': 'Stängt',
    'opening-status-open': 'Öppet',
    'read-more': 'Läs mer',
    'lowestPrice30': '30 day lowest price',
    search: 'Sök…',
    'search-menu': 'Letar du efter något?',
    'language': "Språk",
    'show-all': 'Visa alla',
    'show-on-map': 'Visa på kartan',
    'on-map': 'Kartalla',
    'we-accept': 'Vi godkänner',
    news: 'Aktuellt',
    'other-news': 'Övriga aktuella saker',
    stores: 'Butiker',
    'search-no-result': 'Tyvärr saknar din sökning resultat',
    'toggle-navigation': 'Växla navigering',
    'toggle-search': 'Växla sökning',
    'search-not-match-any-results': 'Inga resultat',
    'store.status.BY_APPOINTMENT': 'Enl. Överenskommelse',
    'store.status.CLOSED': 'Stängt',
    'store.status.OPEN': 'Öpna',
    'store.status.TEMPORARY_CLOSED': 'Tillfälligt stängt',
  },
} as Localizations;

const provider: LocalizationsProvider = {
  namespace: theme_ns,
  localizations: translations,
};

export default provider;
